(function () {
    "use strict";

    angular.module("app.filters", ["app.filters"])
        .filter('fromNow', function () {
            return function (date) {
                if(date !== '' || date.length){
                    return moment(date).fromNow();
                }else{
                    return 'never';
                }
            };
        })
        .filter('LocalConvert', function () {
            return function (date) {
                if(date !== '' || date.length){
                    var localTime  = moment.utc(date()).toDate();
                    return moment(localTime).format('YYYY-MM-DD HH:mm:ss');
                }else{
                    return 'never';
                }

            };
        })
        .filter('userNamefromID', function () {
            return function (items) {
                return items.filter(function (item) {
                    return /a/i.test(item.name.substring(0, 1));
                });
            };
        })
        .filter('fromNowMin', function () {
            return function (date) {
                if(date.length){
                    return moment(date).utc().startOf('min').fromNow();
                }else{
                    return 'never';
                }
            };
        })
        .filter('isFutureDate', function () {
            return function (date) {
                return moment(date).isAfter();
            };
        })


        .filter('objectfindexclude', function() {
            return function(input, str) {
                var tmp = {};
                angular.forEach(input, function(val, key) {
                    if (!value.hasOwnProperty('str')) {
                        tmp[key] = val;
                    }
                });
                return tmp;
            };
        })
        /// really lame lazy filter
        .filter('jsonParseFilter', function () {
            return function (json, filteron) {
                return JSON.parse(json)[filteron];
            };
        })

        .filter('dateToISO', function() {
            return function(input) {
                input = new Date(input).toISOString();
                return input;
            };
        })
        .filter('mediumDate', function () {
            return function (date) {
                return moment(date).utc().format('MMMM Do YYYY, h:mm a');
            };
        })
        .filter('shortDate', function () {
            return function (date) {
                return moment(date).utc().format('MMM Do YYYY, h a');
            };
        })
        .filter('localTime', function () {
            return function (date) {
                return moment(date).utc().format('h:mm a');
            };
        })
        .filter('checkmark', function () {
            return function(input) {
                return input ? '\u2713' : '\u2718';
            };
        })
        .filter('yesno', function () {
            return function(input) {
                return input ? 'Yes' : 'No';
            };
        })
        .filter('customyesno', function () {
            return function(input) {
                if (input === 1) {
                    return 'Yes';
                } else if (input === 0) {
                    return 'No';
                } else if (input === 2) {
                    return 'Archive';
                }
            };
        })
        .filter('failsucceed', function () {
            return function(input) {
                return input ? 'Succeed' : 'Fail';
            };
        })
        .filter('isempty', function () {
            return function(input,replaceText) {
                if(input) return input;
                return replaceText;
            };
        })
        .filter('isJson', function () {
            var output = 1;
            return function(input) {
            try {
                JSON.parse(input);
            } catch (e) {
                output = 0;
            }
            return output;
        };
    });

})();